"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require("babel-runtime/regenerator");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require("babel-runtime/helpers/asyncToGenerator");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _components = require("components");

var _api = require("egov-ui-kit/utils/api");

var _translationNode = require("egov-ui-kit/utils/translationNode");

var _translationNode2 = _interopRequireDefault(_translationNode);

require("./index.css");

var _endPoints = require("egov-ui-kit/utils/endPoints");

var _axios = require("axios");

var _axios2 = _interopRequireDefault(_axios);

var _localStorageUtils = require("egov-ui-kit/utils/localStorageUtils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = {
  logoutContentStyle: { textAlign: "center", padding: "24px 20px" }
};
//logout page//
var LogoutDialog = function LogoutDialog(_ref) {
  var logout = _ref.logout,
      closeLogoutDialog = _ref.closeLogoutDialog,
      logoutPopupOpen = _ref.logoutPopupOpen,
      oktext = _ref.oktext,
      canceltext = _ref.canceltext,
      title = _ref.title,
      body = _ref.body;


  var handleLogoutApi = function () {
    var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
      var authToken, currentPath, payload, response;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              authToken = (0, _localStorageUtils.getAccessToken)();
              currentPath = window.location.origin;
              payload = {
                RequestInfo: {
                  authToken: authToken
                }
              };
              _context.prev = 3;
              _context.next = 6;
              return _axios2.default.post(currentPath + "/services/EGF/rest/ClearToken", payload, {
                headers: {
                  "Content-Type": "application/json"
                }
              });

            case 6:
              response = _context.sent;


              console.log("Logout API Response:", response.data);
              _context.next = 13;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](3);

              console.error("Logout API Error:", _context.t0);

            case 13:

              // After API call → run your actual logout function
              logout();
              localStorage.clear();
              sessionStorage.clear();

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, undefined, [[3, 10]]);
    }));

    return function handleLogoutApi() {
      return _ref2.apply(this, arguments);
    };
  }();
  var actions = [_react2.default.createElement(
    "div",
    { className: "logout-action-wrapper" },
    canceltext ? _react2.default.createElement(_components.Button, {
      id: "logout-no-button",
      className: "logout-no-button",
      label: _react2.default.createElement(_translationNode2.default, { buttonLabel: true, label: canceltext, color: "#FE7A51" }),
      backgroundColor: "#fff",
      onClick: closeLogoutDialog,
      style: { boxShadow: "none" }
    }) : "",
    _react2.default.createElement(_components.Button, {
      id: "logout-yes-button",
      className: "logout-yes-button",
      label: _react2.default.createElement(_translationNode2.default, { buttonLabel: true, label: oktext, color: "#FE7A51" }),
      backgroundColor: "#fff",
      onClick: handleLogoutApi,
      style: { boxShadow: "none" }
    })
  )];
  return _react2.default.createElement(_components.Dialog, {
    open: logoutPopupOpen,
    title: _react2.default.createElement(_translationNode2.default, {
      label: title,
      bold: true,
      color: "rgba(0, 0, 0, 0.8700000047683716)",
      fontSize: "20px",
      labelStyle: { padding: "16px 0px 0px 24px" }
    }),
    children: [_react2.default.createElement(_translationNode2.default, { label: body, color: "rgba(0, 0, 0, 0.6000000238418579)", labelStyle: { padding: "16px 0px 0px 12px" } })],
    handleClose: closeLogoutDialog,
    actions: actions,
    contentClassName: "logout-popup",
    contentStyle: { width: "90%" },
    isClose: true
  });
};

exports.default = LogoutDialog;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/common/common/Header/components/LogoutDialog/index.js
// module id = ../lib/egov-ui-kit/common/common/Header/components/LogoutDialog/index.js
// module chunks = 504